module.exports = __webpack_public_path__ + "img/bookmark-heart.2f4906df.svg";